import { useQuery } from '@tanstack/react-query';
import { useAPI } from '@nexelem/api';

export const useCompetenceAuthorities = (enabled?: boolean) => {
  const api = useAPI();
  return useQuery({
    enabled,
    queryKey: ['competence-authorities'],
    queryFn: () =>
      api.getBackWorkersCompetencesAuthoritySearch({ text: '', maxResults: 1000 }).then((data) => data.results),
  });
};
